import nextIcon from '@/assets/icons/UI/Next.svg?raw'
import prevIcon from '@/assets/icons/UI/Prev.svg?raw'

export const paginatorConfig = () => {
  return {
    background: 'transparent',
    padding: '10px 0',
    // navButtonSelectedBackground: '{green.500}',
    navButtonSelectedColor: 'var(--white)'
  }
}

export const paginatorPt = () => {
  return {
    prev: {
      innerHTML: prevIcon
    },
    next: {
      innerHTML: nextIcon
    }
  }
}
